import {
  MapContainer as Leaflet,
  TileLayer,
  Popup,
  CircleMarker,
  Polyline,
} from 'react-leaflet'
import { PathOptions } from 'leaflet'
import { LocationMarker } from './location-marker/location-marker.component'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { appendPoint } from '../../state/path/path.actions'
import { selectPath } from '../../state/path/path.selectors'
import { MapStyled } from './map.styled'
import colors from '../../theme/colors'
import * as R from 'ramda'
import { selectActivePoint } from '../../state/ui/ui.selectors'

const MapComponent = (props: any) => {
  const defaultCenter = [52.3878729, 13.0583081]
  const pathOptions: PathOptions = { color: colors.path }
  const pointOptions: PathOptions = {
    color: colors.background,
    opacity: 1,
    weight: 6,
    fillColor: colors.light,
    fillOpacity: 1,
    stroke: true,
  }

  const activePointOptions: PathOptions = R.clone(pointOptions)
  activePointOptions.color = colors.path

  return (
    <MapStyled>
      <Leaflet
        center={props.path[0] || defaultCenter}
        zoom={14}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
          url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        />

        <Polyline
          pathOptions={pathOptions}
          positions={props.path || [defaultCenter]}
        />
        {(props.path ? props.path : [defaultCenter]).map(
          (point: [number, number], index: number) => (
            <CircleMarker
              center={point}
              pathOptions={
                index === props.activePoint ? activePointOptions : pointOptions
              }
              radius={index === 0 ? 8 : 5}
              key={`${point[0]}-${point[1]}`}
            >
              <Popup>Waypoint {index + 1}</Popup>
            </CircleMarker>
          )
        )}

        <LocationMarker />
      </Leaflet>
    </MapStyled>
  )
}

const stateProps = createStructuredSelector({
  path: selectPath,
  activePoint: selectActivePoint,
})

const dispatchProps = {
  appendPoint,
}

export const Map = connect(stateProps, dispatchProps)(MapComponent)
